import React from 'react'
import HeroSection from '../Components/HomePageComponents/HeroSection'
import OurClients from '../Components/HomePageComponents/OurClients'
import RepairServiceSection from '../Components/HomePageComponents/RepairServiceSection'
import HowItWorks from '../Components/HomePageComponents/HowItWorks'
import BookingForm from '../Components/HomePageComponents/BookingForm'
import Services from '../Components/HomePageComponents/Services'
import Testimonials from '../Components/HomePageComponents/Testimonials'
import WhyChooseUs from '../Components/HomePageComponents/WhyChooseUs'

const Home = () => {
  return (
    <div>
        <HeroSection />
        <OurClients />
        <RepairServiceSection/>
        <WhyChooseUs />
        <HowItWorks />
        <BookingForm />
        {/* <Services /> */}
        <Testimonials />


    </div>
  )
}

export default Home